import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const recouvrementsSlice = createSlice({
    name: 'recouvrements',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsRecouvrements.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsRecouvrements.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.data = action.payload
        })
        .addCase(fetchDetailsRecouvrements.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
        
        .addCase(fetchMailRecouvrements.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchMailRecouvrements.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.mail = action.payload
        })
        .addCase(fetchMailRecouvrements.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchRecouvrements.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchRecouvrements.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchRecouvrements.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createRecouvrement.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createRecouvrement.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createRecouvrement.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteRecouvrement.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteRecouvrement.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteRecouvrement.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})
// Async thunk action to fetch details from the API
export const fetchDetailsRecouvrements = createAsyncThunk(
    'Recouvrements/fetchDetails',
    async (id) => {
        const data = {'idf':id.id}
        try {
            const Recouvrement = await BaseService.post(
                `/XML/compta.factc.load/side_details_fact`,data
            )
            const content = await BaseService.post(
                `/XML/compta.factc.load/calc_fact_by_id`,data
            )
                const Client = await BaseService.post(
                `/XML/ve.cl.load/get_one_cl`,{'idcl':Recouvrement.data.fact[0].idcl}
            )
            return {Recouvrement:Recouvrement.data,content:content.data,Client:Client.data}
        } catch (error) {
            throw new Error('Failed to fetch Recouvrements')
        }
    }
)
// Async thunk action to fetch data from the API
export const fetchRecouvrements = createAsyncThunk(
    'recouvrements/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/compta.factc.load/get_recouvrement?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch recouvrements')
        }
    }
)



export const fetchMailRecouvrements = createAsyncThunk(
    'recouvrementsMail/fetch',
    async (payload) => {
        const id = payload?.id
        
        try {
            const response = await BaseService.get(
                `/XML/compta.factc.load/getMailRecouvrement?id=${id}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch recouvrements')
        }
    }
)

export const createRecouvrement = createAsyncThunk(
    'recouvrements/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/recouvrements', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/recouvrements')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editRecouvrement = createAsyncThunk('recouvrements/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/recouvrements/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/recouvrements')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deleteRecouvrement = createAsyncThunk(
    'recouvrement/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/recouvrements/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.recouvrements.data
export const selectIsLoading = (state) => state.recouvrements.isLoading
export const selectError = (state) => state.recouvrements.error
export const selectIsDeleted = (state) => state.recouvrements.isDeleted
export const selectCurrentPage = (state) => state.recouvrements.currentPage

export default recouvrementsSlice.reducer
